const staleChunkErrorPatterns = [
  'Failed to fetch dynamically imported module',
  'Failed to load module script',
  'Expected a JavaScript-or-Wasm module script',
  'Expected a JavaScript module script',
  'Importing a module script failed',
  'error loading dynamically imported module',
  'Unable to preload CSS',
  'ChunkLoadError',
  'Loading chunk',
  'dynamically imported module',
];

const getErrorText = (error: unknown): string => {
  if (error instanceof Error) return `${error.name}: ${error.message}`;
  if (typeof error === 'string') return error;
  if (error && typeof error === 'object') {
    const candidate = error as { message?: unknown; data?: unknown; cause?: unknown };
    return [candidate.message, candidate.data, candidate.cause]
      .map(value => (typeof value === 'string' ? value : getErrorText(value)))
      .filter(Boolean)
      .join(' ');
  }
  return '';
};

export const isStaleChunkError = (error: unknown): boolean => {
  const text = getErrorText(error);
  return staleChunkErrorPatterns.some(pattern => text.includes(pattern));
};

export const canRetryChunkRecovery = (attempts: number, maxAttempts = 2): boolean =>
  attempts < maxAttempts;
